import request from 'superagent'

import {
    FLOWERAI_CLOUD_PLANT,
    FLOWERAI_CLOUD_PLANT_LIST,
    FLOWERAI_CLOUD_FAVORITE_PLANTS
} from '../constants/urls'

export const GET_PLANT = 'GET_PLANT'
export function getPlant(id, language = 'de-DE') {
    const req = request
        .get(FLOWERAI_CLOUD_PLANT.replace(':id', id))
        .query({
            country: language,
        })
        .auth('admin', 'supersecret')

    return {
        type: GET_PLANT,
        payload: req,
    }
}

export const LOADING_PLANT_LIST = 'LOADING_PLANT_LIST'
export function loadPlantList() {
    return {
        type: LOADING_PLANT_LIST,
        payload: true,
    }
}

export const GET_PLANT_LIST = 'GET_PLANT_LIST'
export function getPlantList(searchQuery, filters, page = 1, language = 'de-DE') {
    const query = {
        country: language,
        search: searchQuery,
        page,
        limit: 20,
    }

    if (filters.location && filters.location !== 'NOT_SPECIFIED') {
        query.location = filters.location
    }

    if (filters.waterdemand && filters.waterdemand !== 'NOT_SPECIFIED') {
        query.waterdemand = filters.waterdemand
    }

    if (filters.cuttingtime && filters.cuttingtime !== 'NOT_SPECIFIED') {
        query.cuttingtime = filters.cuttingtime
    }

    const req = request
        .get(FLOWERAI_CLOUD_PLANT_LIST)
        .query(query)
        .auth('admin', 'supersecret')

    return {
        type: GET_PLANT_LIST,
        payload: req,
        meta: {
            searchQuery,
        },
    }
}

export const SET_FAVORITE_PLANT = 'SET_FAVORITE_PLANT'
export function setFavoritePlant(id, isSet = false, userId, token) {
    const req = request
        .post(FLOWERAI_CLOUD_FAVORITE_PLANTS.replace(':userId', userId))
        .send({
            token,
            plantId: id,
            isFavorite: !isSet,
        })
        .auth('admin', 'supersecret')

    return {
        type: SET_FAVORITE_PLANT,
        payload: req,
        meta: {
            analytics: {
                eventType: 'interaction',
                eventPayload: {
                    interaction_value: 'undefined',
                    interaction_category: 'Plant-List',
                    interaction_action: 'click-favorite-plant',
                    interaction_label: !isSet ? 'mark-favorite' : 'undo-favorite',
                },
            },
        },
    }
}

export const GET_FAVORITE_PLANTS = 'GET_FAVORITE_PLANTS'
export function getFavoritePlants(userId, token) {
    const req = request
        .get(FLOWERAI_CLOUD_FAVORITE_PLANTS.replace(':userId', userId))
        .query({
            token,
        })
        .auth('admin', 'supersecret')

    return {
        type: GET_FAVORITE_PLANTS,
        payload: req,
    }
}

export const TOGGLE_SEARCH_PLANT = 'TOGGLE_SEARCH_PLANT'
export function togglePlantSearch(active) {
    return {
        type: TOGGLE_SEARCH_PLANT,
        payload: active,
    }
}

export const TOGGLE_FILTER_PLANT = 'TOGGLE_FILTER_PLANT'
export function togglePlantFilter(name, active) {
    return {
        type: TOGGLE_FILTER_PLANT,
        payload: {
            active,
            name,
        },
    }
}

export const CHANGE_SEARCH_QUERY = 'CHANGE_SEARCH_QUERY'
export function changeSearchQuery(searchQuery) {
    return {
        type: CHANGE_SEARCH_QUERY,
        payload: searchQuery,
    }
}

export const LOADING_PLANT_SEARCH = 'LOADING_PLANT_SEARCH'
export function loadPlantSearch() {
    return {
        type: LOADING_PLANT_SEARCH,
        payload: true,
    }
}

export const RESET_SEARCH_PLANT = 'RESET_SEARCH_PLANT'
export function resetPlantSearch() {
    return {
        type: RESET_SEARCH_PLANT,
        payload: null,
    }
}

export const RESET_FILTERED_PLANTS = 'RESET_FILTERED_PLANTS'
export function resetPlantFilters() {
    return {
        type: RESET_FILTERED_PLANTS,
        payload: null,
    }
}

export const GET_PLANT_RECOMMENDATIONS = 'GET_PLANT_RECOMMENDATIONS'
export function getPlantRecommendations(location, waterdemand, cuttingtime, language = 'de-DE') {
    const query = {
        country: language,
        search: '',
        page: 1,
        limit: 20,
    }

    if (location && location !== 'NOT_SPECIFIED') {
        query.location = location
    }

    // TODO: ADD AGAIN WHEN WATER DEMAND IS FILLED IN DB CONFIDENTLY
    // if (waterdemand && waterdemand !== 'NOT_SPECIFIED') {
    //     query.waterdemand = waterdemand
    // }

    if (cuttingtime && cuttingtime !== 'NOT_SPECIFIED') {
        query.cuttingtime = cuttingtime
    }

    const req = request
        .get(FLOWERAI_CLOUD_PLANT_LIST)
        .query(query)
        .auth('admin', 'supersecret')

    return {
        type: GET_PLANT_RECOMMENDATIONS,
        payload: req,
    }
}

export const RESET_PLANT_RECOMMENDATIONS = 'RESET_PLANT_RECOMMENDATIONS'
export function resetPlantRecommendations() {
    return {
        type: RESET_PLANT_RECOMMENDATIONS,
        payload: null,
    }
}

export const LOAD_PLANT_RECOMMENDATIONS = 'LOAD_PLANT_RECOMMENDATIONS'
export function loadPlantRecommendations() {
    return {
        type: LOAD_PLANT_RECOMMENDATIONS,
        payload: null,
    }
}



// WEBPACK FOOTER //
// ./src/actions/plants.js